<template>
    <div class="wrapperNav box_shadow1">
        <div class="nav" id="nav">
            <div class="nav_content">
                <div class="nav_item">
                    <router-link to="/" exact :class="{cur:isCur,isNavAnnouncebg:isNavAnnouncebg}">
                        <div class="a_center">
                            <!-- <van-icon name="notes-o" /> -->
                            <i class="notes"></i>
                            <span>公告</span>
                        </div>
                    </router-link>
                </div>
                <div class="nav_item">
                    <em class="l_line" v-if="isLeftLine"></em>
                    <em class="r_line" v-if="isRightLine"></em>
                    <router-link to="/discuss" :class="{isActive:isActive}">
                        <div class="a_center">
                            <!-- <van-icon name="chat-o" /> -->
                            <i class="discuss"></i>
                            <span>討論</span>
                        </div>
                    </router-link>
                </div>
                <div class="nav_item">
                    <router-link to="/myInfo" :class="{isNavMybg:isNavMybg}">
                        <div class="a_center">
                            <!-- <van-icon name="friends-o" /> -->
                            <i class="my"></i>
                            <span>我的</span>
                        </div>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:'HomeNav',
    data() {
        return {
            isNavAnnouncebg:true,
            isNavMybg:true
        }
    }
}
</script>

<style lang="stylus" scoped>
@media all and (orientation : landscape)
    .van-icon
        display inline-block
        color #fe8124
        vertical-align middle
        font-size 0.475rem
        margin-right: .2rem
    .wrapperNav
        width 86%
        height 1.12rem
        margin -.26rem auto 0
        border-radius 0.1rem
        position sticky
        position -webkit-sticky
        top -.04rem
        z-index 10
    .nav
        display flex
        height 100%
        text-align center
        margin-left 0
        .nav_content
            position: relative
            z-index: 8
            display flex
            width 100%
            height 100%
            margin 0 auto
            background url('../assets/img/nav_bg0.png') no-repeat
            background-size 100% 100%
            .nav_item
                position relative
                flex 1
                height .96rem
                line-height 1rem
                z-index 1
                color #d2a852
                box-sizing border-box
                margin-top 0.029999998rem
                &:nth-child(1)
                    margin-left 0.06rem
                &:nth-child(2)
                    margin-right 0.06rem
                    em
                        display inline-block
                        position absolute
                        width .04rem
                        height .59rem
                        top 50%
                        margin-top -.295rem
                        background url('../assets/img/nav_line.png') no-repeat
                        background-size 100% 100%
                        &.l_line
                            left 0
                        &.r_line
                            right 0
                a
                    display block
                    position relative
                    width: 100%
                    height: 100%
                    box-sizing border-box
                    display: flex
                    align-items: center
                    justify-content: center
                    .a_center
                        width: 100%
                        vertical-align: middle
                        i
                            display inline-block
                            vertical-align middle
                            margin-right .2rem
                            background url('../assets/img/icon.png') no-repeat
                            background-size 1.12rem 2.68rem
                            &.notes
                                width .36rem
                                height .36rem
                                background-position 0 -1.01rem
                            &.discuss
                                width .41rem
                                height .36rem
                                background-position 0 -2.35rem
                            &.my
                                width .34rem
                                height .36rem
                                background-position -0.62rem -0.76rem
                span
                    color #fe8124
                    vertical-align middle
                    font-size: .3rem
@media all and (orientation : portrait)
    .van-icon
        color #d2a852
        padding-right .03rem
        font-size 0.395rem
        vertical-align middle
    .nav
        display flex
        width 100%
        height .53rem
        text-align center
        position fixed
        z-index 1
        top .43vh
        background #000
        padding 1% 0
        .nav_content
            display flex
            width 99%
            height 100% !important
            margin 0 auto
            .nav_item
                flex .9
                background #333333
                border-radius .1rem
                margin-left 1.5%
                height: .6rem !important
                line-height: .6rem
                color #d2a852
                font-size .255rem
                a
                    display block
                    color #d2a852
                    width: 100%
                    height: 100%
                    box-sizing border-box
                    border-radius 0.1rem
                    background #333333
                    border 1px solid #797979
                span
                    display inline-block
                    vertical-align middle
                    line-height 0.3rem
                &:nth-child(1)
                    margin-left:0
</style>